<template>
    <div class="main">
      <div class="login">
        <div class="title">
          <span>OTA后台管理系统</span>
        </div>
        <el-form
          ref="form"
          :model="dataFrom"
          :rules="rules"
      
          class="demo-form-inline"
        >
          <el-form-item label="" prop="username">
            <el-input
              prefix-icon="el-icon-user"
              placeholder="请输入账号"
              v-model="dataFrom.username"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input
              prefix-icon="el-icon-unlock"
              placeholder="请输入密码"
              show-password
              v-model="dataFrom.password"
            ></el-input>
          </el-form-item>
          <el-form-item label="" prop="code">
            <el-input
              prefix-icon="el-icon-document-checked"
              placeholder="请输入验证码"
              v-model="dataFrom.code"
            ></el-input>
           
          </el-form-item>
      
            <div class="getCode">
              <img @click="getLoginCode" :src="codeSrc" />
            </div>
          
        </el-form>
        <div class="btn">
          <button @click="submitForm">登录</button>
        </div>
      </div>
      <div class="copyright">Copyright © 2025.</div>
    </div>
  </template>
  <script>
  import { postPasLogin } from '@/api/userService';
  export default {
    data() {
      const validateUsername = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入账号'));
        } else {
          callback();
        }
      };
      const validatePassword = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      const validateCode = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入验证码'));
        } else {
          callback();
        }
      };
      return {
        dataFrom: {
          username: "",
          password: "",
          code: ""
        },
        codeSrc: "",
        rules: {
          username: [
            { validator: validateUsername, trigger: 'blur' }
          ],
          password: [
            { validator: validatePassword, trigger: 'blur' }
          ],
          code: [
            { validator: validateCode, trigger: 'blur' }
          ]
        }
      };
    },
    mounted() {
      this.getLoginCode();
    },
    methods: {
      submitForm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            postPasLogin(this.dataFrom).then((res) => {
              if (res.data.code == 0) {
                this.$message.success('登录成功');
                localStorage.setItem("token", res.data.data.token);
                localStorage.setItem("username", res.data.data.username);
                console.log(localStorage.getItem("username"));
                console.log(localStorage.getItem("token"));
                this.$router.push("./home");
              } else {
                this.$message.error('登录失败');
                this.getLoginCode();
              }
            });
          } else {
            return false;
          }
        });
      },
      getLoginCode() {
        this.codeSrc = 'http://35.170.50.219/admin/auth/captcha?t=' + new Date().getTime();
      }
    }
  };
  </script>
  <style scoped>
  .main {
    background: url("../../assets/img/bg-login.jpeg");
    background-size: 100% 100%;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .login {
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #FFFFFF;
    background: #fff;
    width: 300px;
    padding: 30px 30px 50px 30px;
    border-radius: 3px;
  }
  .login .title {
    text-align: center;
    margin: 0 0 10px 0;
  }
  .login .title span {
    color: #304B6E;
    font-weight: 400;
    font-size: 20px;
  }

  .login .list {
    display: flex;
    align-items: center;
    padding: 15px 0;
  }
  .login .list input {
    border-radius: 3px;
    border: none;
    outline: none;
    color: #999;
    border: 1px solid #bdbdbd;
    font-size: 14px;
    line-height: 50px;
    padding: 0 10px;
    display: block;
    box-sizing: border-box;
    flex: 7;
  }

  .login .list .getCode span {
    font-size: 20px;
    background: #f5f7fa;
    color: #777;
    border-radius: 4px;
    line-height: 40px;
    border: 1px solid #ccc;
    display: inline-block;
    margin-left: 10px;
    width: 80px;
    text-align: center;
    user-select: none;
    cursor: pointer;
  }

  .btn {
    display: flex;
    justify-content: flex-end;
    padding-top: 5px;
  }
  .btn button {
    font-size: 13px;
    color: #fff;
    background: #1890FF;
    outline: none;
    border: none;
    line-height: 40px;
    padding: 0 20px;
    display: inline-block;
    flex: 1;
    cursor: pointer;
    border-radius: 3px;
  }
  .copyright{
    color: #eee;
    text-align: center;
    position:fixed;
    z-index: 1;
    bottom:20px;
    left:0;
    right:0;
    font-size:14px;
  }
  .login .demo-form-inline .el-form-item {
      display: inline-block;
      width: 100%;
      /* // 修改此处，添加负的 margin-left 让元素左移 */
      margin-left: -10px;
      padding-left: 0;
      /* margin-right: 10px; */
  }
  .el-form-item {
    display: flex;
    align-items: center;
}

.getCode {
    margin-left: 10px; /* 可根据需要调整距离 */
}
  </style>



// WEBPACK FOOTER //
// src/views/Login/Login.vue